import { useMinute } from '@/hooks/useNow'
import { ago, ahead, duration } from '@/ui/format'

// 분까지인 상대 시각 — `3분 전`(`ago`)·`12분 뒤`(`ahead`)·`3시간 12분`(`duration`). 같은 폴링 응답은 화면을 다시
// 그리지 않으므로(`ui/share.ts`) 이 글자는 `hooks/useNow.ts` 의 1분 틱으로 저 혼자 흐른다. 컴포넌트가 따로 있는
// 이유는 그 틱이 이 글자에만 머물게 하는 것이다 — 화면 전체나 목록의 줄이 1분마다 다시 그려지지 않는다.
// 감싸는 요소를 더하지 않는다: 글꼴·색은 부르는 쪽의 것이고, 둘레의 글자와 한 글자 덩어리로 읽힌다.

type At = { at: string | null | undefined }

/** 언제였나. `방금`·`3분 전`·`5시간 전`·`2일 전`. */
export function Ago({ at }: At) {
  const now = useMinute()
  return <>{ago(at, now)}</>
}

/** 앞으로 남은 때. `곧`·`12분 뒤`·`3일 뒤`. */
export function Ahead({ at }: At) {
  const now = useMinute()
  return <>{ahead(at, now)}</>
}

/** 그때부터 지금까지. `1분 미만`·`3시간 12분`·`2일 4시간`. */
export function Duration({ at }: At) {
  const now = useMinute()
  return <>{duration(at, now)}</>
}
